interface VendorOrderQueueHeaderProps {
  title?: string
  subtitle?: string
  metricsTemplate?: string
  activeOrdersCount: number
  totalOrdersCount: number
}

export function VendorOrderQueueHeader({
  title,
  subtitle,
  metricsTemplate,
  activeOrdersCount,
  totalOrdersCount,
}: VendorOrderQueueHeaderProps) {
  return (
    <div className="flex flex-col justify-between border-b border-border/50 pb-6 sm:flex-row sm:items-end">
      <div>
        <h1 className="font-display text-4xl uppercase tracking-widest text-foreground">
          {title || "Logistics Oversight"}
        </h1>
        <p className="mt-1 text-sm font-medium text-muted-foreground">
          {subtitle || "Validate stock levels and approve fulfillment stages."}
        </p>
      </div>
      <div className="mt-4 sm:mt-0">
        <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
          {metricsTemplate
            ?.replace("{active}", activeOrdersCount.toString())
            .replace("{pending}", totalOrdersCount.toString()) ||
            `QUEUE: ${activeOrdersCount} ACTIVE OF ${totalOrdersCount} TOTAL`}
        </p>
      </div>
    </div>
  )
}
